import {
  decodeHtml,
  timeToSeconds,
  returnWidthPercent,
  cmsImageResize,
} from '../helpers';
import React, { useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { fetchProgAvail } from '../actions';
import translate from './TranslateHOC';
import { BASE_URL, SIGNED_URL_STRING } from '../constants';
import { Card as CardV2 } from '../v2/components/card/Card';
import { CardLoading } from '../v2/components/loading/CardLoading';

function Card({
  details: {
    id,
    series_id,
    title,
    subTitle,
    thumbnail,
    available,
    clic_aired,
    count,
    last_player_pos,
    duration,
    isCMSThumbnail,
    isLive,
    isExtraFeed,
    isHero,
  },
  details,
  strings,
  orientation,
  children,
  signed,
  isSlick,
  tag,
  countBool,
  playNow,
  cardBtn,
  fetchProgAvail,
  checkAvail,
  isToday,
  active,
  seriesLevel,
  progAvail,
  type,
}) {
  // pulled this from details - just disabling on cards for now
  //const isActions = false;

  const progAvailCheck = (id, data) => {
    return data?.length ? data.includes(id) : true;
  };

  const imageURL =
    thumbnail && isCMSThumbnail
      ? cmsImageResize(thumbnail, '300x169')
      : `${BASE_URL}amg/landscape/300x169/${thumbnail}`;

  //const billingTrunc = truncateStr(billing, 85);
  //const billingBoolCheck = billingBool ? true : false;

  const progLinkUrl = () => {
    if (seriesLevel && series_id) {
      return `/series/${series_id}`;
    }
    if (signed) {
      return `/programme/${id}/${SIGNED_URL_STRING}`;
    }
    if (isLive) {
      return isExtraFeed ? `/Live/${id}` : '/Live';
    }
    if (isHero) {
      return `${id}`;
    }
    return `/programme/${id}`;
  };

  let progLink = progLinkUrl();
  if (playNow) {
    progLink += '?play';
  }

  /* Add recommendationId to url if available */
  const { recommendationId } = details;
  if (recommendationId) {
    const separator = progLink.includes('?') ? '&' : '?';
    progLink += `${separator}recommendationId=${recommendationId}`;
  }

  let isUnavailable =
    available !== undefined && available === false ? true : false;

  //Additional unavailable check here - check the programme is available yet by querying separate api
  if (checkAvail && progAvail?.length > 0 && progAvailCheck(id, progAvail)) {
    isUnavailable = true;
  }

  // subtitle logic
  // 1. if Countbool true the show number of eps
  // 2. else if subTitle exists, the decode and show
  // 3. else show when aired
  // 3. else return null
  const subTitleStr = useMemo(() => {
    if (countBool) {
      return `${count} ${strings.episodes}`;
    }
    if (subTitle) {
      return decodeHtml(subTitle);
    }
    if (clic_aired) {
      return `${clic_aired}`;
    }
    return null;
  }, [count, countBool, subTitle, clic_aired, strings.episodes]);

  useEffect(() => {
    if (checkAvail) {
      fetchProgAvail(details.id);
    }
  }, [checkAvail, details.id]);

  if (!details) {
    return <CardLoading />;
  }

  return (
    <CardV2
      state={isUnavailable ? 'unavailable' : 'available'}
      url={progLink}
      orientation={orientation}
      image={imageURL}
      tag={tag ? decodeHtml(tag) : null}
      title={title ? decodeHtml(title) : null}
      subtitle={seriesLevel ? '' : subTitleStr}
      progress={returnWidthPercent(timeToSeconds(duration), last_player_pos)}
      altText={
        title ? decodeHtml(title) : subTitle ? decodeHtml(subTitle) : null
      }
      isSlick={isSlick}
      children={children}
      cardBtn={cardBtn}
      details={details}
      isLive={isLive}
      onLater={isExtraFeed}
      isToday={isToday}
      strings={strings}
      active={active}
      type={type}
      // billing={billingBoolCheck ? billingTrunc : ''}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    progAvail: state.fetchProgAvail,
    progAvailIsLoading: state.fetchProgAvailIsLoading,
    progAvailHasErrored: state.fetchProgAvailHasErrored,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProgAvail: (id) => dispatch(fetchProgAvail(id)),
  };
};

export default translate(connect(mapStateToProps, mapDispatchToProps)(Card));
